import React from 'react'
import { ReactElement } from 'react'

import { Col, FormRow } from '../../../../../1stlog-ui/src/components/Bootstrap'
import Checkbox from '../../../../../1stlog-ui/src/components/Checkbox'
import Field, {
  mustBeEmail,
  useField,
} from '../../../../../1stlog-ui/src/components/Field'
import useFieldValue from '../../../../../1stlog-ui/src/components/Field/useFieldValue'
import Icon from '../../../../../1stlog-ui/src/components/Icon'
import Input from '../../../../../1stlog-ui/src/components/Input'

const EmailLabelRequested = (): ReactElement => {
  const requestLabelPrint = useFieldValue('requestLabelPrint')

  const email = useField('pickup.address.mail', {
    onlyValid: true,
  })

  return (
    <div>
      <div>
        <FormRow>
          <Col>
            <Field
              name="requestLabelPrint"
              validateFields={['pickup.address.mail']}
            >
              <Checkbox
                label={i18n.t(
                  'send_label_via_email',
                  'Label per E-mail versenden',
                )}
              />
            </Field>
          </Col>
        </FormRow>
        {Boolean(requestLabelPrint) && (
          <>
            <FormRow>
              <Col>
                <Field
                  name="pickup.address.mail"
                  label={i18n.t(
                    'label_print_email_receiver',
                    'E-Mail Adresse des Labelempfängers',
                  )}
                  validate={mustBeEmail}
                >
                  <Input />
                </Field>
                {!email && (
                  <div className="text-warning mb-1">
                    <Icon icon="fas fa-exclamation-triangle" />{' '}
                    {i18n.t(
                      'info_no_label_without_email',
                      'Ohne E-Mail Adresse wird kein Label per E-Mail versendet.',
                    )}
                  </div>
                )}
              </Col>
            </FormRow>
          </>
        )}
      </div>
    </div>
  )
}

export default EmailLabelRequested
